import { Maybe } from '@aibees/shared/definition';
import { useMemo } from 'react';

export function useCalculateTotalCredits(
  contactCredits: Maybe<number>,
  aiPersonalityCredits: Maybe<number>
) {
  return useMemo(
    () => (contactCredits ?? 0) + (aiPersonalityCredits ?? 0),
    [contactCredits, aiPersonalityCredits]
  );
}
